<input #inputElement matInput [value]="inputValue()" [placeholder]="'sharedDialogs.addNewCompanyAddress.enterAddress' | transloco" [required]="required"
  (input)="onInputTextChange($event.target)" (focus)="onInputFocus()" (blur)="onInputBlur()"/>

<ng-template #autocompleteTemplate>
  @if (addressOptions$ | async; as addresses) {
  <div class="autocomplete-wrapper">
    <div class="autocomplete-results">
       @for (address of addresses; track address.id) {
        <div class="address-row" (mousedown)="onOverlayMouseDown($event)" (click)="selectAddress(address)">
          <mat-icon svgIcon="landmark"></mat-icon>
          <span [innerHTML]="highlightAddressMatch(address)"></span>
        </div>
       }
    </div>
    <div class="manual-entry">
      <button mat-button (mousedown)="onOverlayMouseDown($event)" (click)="addNew()" [disabled]="addresses.length > 0">
        <mat-icon>add</mat-icon>
        {{ 'sharedDialogs.addNewCompanyAddress.addAddress' | transloco }}
      </button>
      <span>{{ inputValue() }}</span>
    </div>
  </div>
  }

</ng-template>